<template>
    <v-container fluid>
      <v-row>
        <v-col class="col-12 pt-0 pb-2">
          <v-row>
            <v-col class="col-4">
              <h1>View {{ supplier.name }}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-12 pt-0 pb-0">
              <router-link :to="`/purchasing/suppliers-edit/${supplier.id}`">
                <v-btn small>Edit</v-btn>
              </router-link>
              &nbsp;
              <router-link :to="`/purchasing/create-po/${supplier.id}`">
                <v-btn small>Raise PO</v-btn>
              </router-link>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
                {{ supplier.name }}
            </v-col>
          </v-row>
          <v-row v-if="supplier.supplier_category">
            <v-col class="col-4">
              Category: {{ supplier.supplier_category.category }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              <span v-if="supplier.address_1">{{ supplier.address_1 }}<br /></span>
              <span v-if="supplier.address_1">{{ supplier.address_2 }}<br /></span>
              <span v-if="supplier.address_1">{{ supplier.address_3 }}<br /></span>
              <span v-if="supplier.address_1">{{ supplier.address_4 }}<br /></span>
              <span v-if="supplier.post_code">{{ supplier.post_code }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              Telephone: {{ supplier.telephone }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              Email: {{ supplier.email }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              Main contact: {{ supplier.main_contact }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              Type of supply: {{ supplier.type_of_supply }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import axios from '../../axios';
  
  export default {
    name: 'ViewSupplier',
    data() {
      return {
        supplier: {
          supplier_category_id: 0,
          name: '',
          address_1: '',
          address_2: '',
          address_3: '',
          address_4: '',
          post_code: '',
          telephone: '',
          fax: '',
          email: '',
          main_contact: '',
          type_of_supply: '',
          supplier_category: {
            'id':0,
            'category':'',
          },
        },
      };
    },
    computed: {
      token() {
        return this.$store.state.token;
      },
    },
    methods: {
      getSupplier() {
        const supplierId = this.$route.params.id;
        axios.get(`/suppliers/get/${supplierId}.json?token=${this.token}`)
          .then((response) => {
            this.supplier = response.data.supplier;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
    mounted() {
      this.getSupplier();
    },
  }
  </script>
  